import React from 'react';
import { HomeNavigator } from './HomeNavigator';
import { SettingsNavigator } from './SettingsNavigator';
import { View, Button, StyleSheet, TouchableOpacity } from 'react-native';
import { Color, CommonProperties, CommonStyles } from '../styles';
import { createStackNavigator } from '@react-navigation/stack';
import { DrawerActions } from '@react-navigation/native';
import {
  createDrawerNavigator,
  DrawerContentScrollView,
  DrawerItem,
} from '@react-navigation/drawer';
import BaseText from '../components/BaseText';
import { Screens, Modals, Stacks } from '../constants/ScreenNames';
import moment from 'moment';
import {
  // ContactNavigator,
  // TermsNavigator,
  // PrivacyNavigator,
  IconNavigator,
} from './DrawerStackNavigators';
import { BottomTabs } from './BottomTabNavigator';
import { useSelector, useDispatch } from 'react-redux';
import * as authActions from '../store/actions/auth';
import {
  defaultStackHeaderOptions,
  allowStackToScrollOnWebOption,
} from '../utils/defaultNavOptions';
import { useNavigation } from '@react-navigation/native';
import { changeCdnUrl } from '../utils/common.utils';

import CustomDrawerItemList from './CustomDrawerItemList';
import Icon from '../components/Icon';

import Avatar from '../components/Avatar';
import { selectMytrips, selectMytripsCount } from '../store/selectors/mytrips.selector';
import { selectUserProfileImage } from '../store/selectors/profile.selector';
import { useTranslation } from 'react-i18next';
import { lngMap } from '../i18n';

import FlightScreen from '../screens/FlightScreen';
import HotelScreen from '../screens/HotelScreen';
import CarScreen from '../screens/CarScreen';
import RailScreen from '../screens/RailScreen';
import TripSummaryScreen from '../screens/TripSummaryScreen';
import PassengerScreen from '../screens/PassengerScreen';
import PurchaseScreen from '../screens/PurchaseScreen';
import HotelDetailScreen from '../screens/HotelDetailScreen';
import ReceiptScreen from '../screens/ReceiptScreen';
import SeatScreen from '../screens/SeatScreen';
import PrivacyModal from '../components/settings/legal/PrivacyModal';
import TermsModal from '../components/settings/legal/TermsModal';
import TripHubScreen from '../screens/TripHubScreen';
import AirChangeScreen from '../screens/TripHub/AirChangeScreen';
import CarChangeScreen from '../screens/TripHub/CarChangeScreen';
import RailChangeScreen from '../screens/TripHub/RailChangeScreen';
import RoomsScreen from '../screens/TripHub/RoomsScreen';
import { AA_ENABLED, EVENTS_ENABLED, REBOOK_ENABLED, CREW_ENABLED } from '../config/env';
import RebookHomeScreen from '../screens/Rebook/RebookHomeScreen';
import { selectTezEvent } from '../store/selectors/events.selector';
import { selectTrip } from '../store/actions/mytrips';
import FlightCloudScreen from '../screens/FlightCloudScreen';
import EasyCardScreen from '../screens/EasyCardScreen';
import { EXPENSE_SUB_TAB_OPTIONS, userTypes } from '../constants/Enums';
import { isExpenseAllowed } from '../store/selectors/profile.selector';
import ProfileHeader from '../components/ProfileHeader';
import { selectExpenseList } from '../store/selectors/expense.selector';
import { isNullOrEmpty } from '../utils/common.utils';

const { RECEIPTS, CHARGES, MILEAGE, MANUAL } = EXPENSE_SUB_TAB_OPTIONS;
const MainStackNavigator = createStackNavigator();
export const MainNavigator = () => {
  const { t } = useTranslation();
  let tempInitialRouteName = 'Drawer';
  if (REBOOK_ENABLED) {
    tempInitialRouteName = 'RebookHome';
  }
  return (
    <MainStackNavigator.Navigator
      screenOptions={{ ...defaultStackHeaderOptions, ...allowStackToScrollOnWebOption }}
      initialRouteName={tempInitialRouteName}
    >
      <MainStackNavigator.Screen
        options={{ headerShown: false }}
        name={Screens.RebookHome}
        component={RebookHomeScreen}
      />

      <MainStackNavigator.Screen
        name="Drawer"
        component={DrawerNavigator}
        options={{
          title: '',
          headerShown: false,
          cardStyle: { backgroundColor: Color.accent },
          // cardStyle: {{AA_ENABLED ? border}}
        }}
      />
      <MainStackNavigator.Screen name={Screens.FlightCloud} component={FlightCloudScreen} />
      <MainStackNavigator.Screen name={Screens.Flight} component={FlightScreen} />
      <MainStackNavigator.Screen name={Screens.Hotel} component={HotelScreen} />
      <MainStackNavigator.Screen name={Screens.HotelDetail} component={HotelDetailScreen} />
      <MainStackNavigator.Screen name={Screens.Car} component={CarScreen} />
      <MainStackNavigator.Screen name={Screens.Rail} component={RailScreen} />
      <MainStackNavigator.Screen name={Screens.EasyCardScreen} component={EasyCardScreen} />
      <MainStackNavigator.Screen
        name={Screens.TripSummary}
        component={TripSummaryScreen}
        options={{
          title: t('MainStackNavigator.TripSummary'),
        }}
      />
      <MainStackNavigator.Screen
        name={Screens.Passenger}
        component={PassengerScreen}
        options={{
          title: t('MainStackNavigator.Passenger'),
        }}
      />
      <MainStackNavigator.Screen
        name={Screens.Seat}
        component={SeatScreen}
        options={{
          title: t('MainStackNavigator.Seat'),
        }}
      />
      <MainStackNavigator.Screen
        name={Screens.Purchase}
        component={PurchaseScreen}
        options={{
          title: t('MainStackNavigator.Purchase'),
        }}
      />
      <MainStackNavigator.Screen
        name={Screens.PrivacyPolicy}
        component={PrivacyModal}
        options={{
          title: t('MainStackNavigator.PrivacyPolicy'),
        }}
      />
      <MainStackNavigator.Screen
        name={Screens.TermsOfUse}
        component={TermsModal}
        options={{
          title: t('MainStackNavigator.TermsOfUse'),
        }}
      />
      <MainStackNavigator.Screen
        name={Screens.Receipt}
        component={ReceiptScreen}
        options={{
          title: t('MainStackNavigator.Receipt'),
          defaultStackHeaderOptions,
        }}
      />
      <MainStackNavigator.Screen
        name={Screens.TripHub}
        component={TripHubScreen}
        options={defaultStackHeaderOptions}
      />
      <MainStackNavigator.Screen
        name={Screens.AirChange}
        component={AirChangeScreen}
        options={defaultStackHeaderOptions}
      />
      <MainStackNavigator.Screen
        name={Screens.CarChange}
        component={CarChangeScreen}
        options={defaultStackHeaderOptions}
      />
      <MainStackNavigator.Screen
        name={Screens.RailChange}
        component={RailChangeScreen}
        options={defaultStackHeaderOptions}
      />
      <MainStackNavigator.Screen
        name={Screens.Rooms}
        component={RoomsScreen}
        options={defaultStackHeaderOptions}
      />
    </MainStackNavigator.Navigator>
  );
};

const MainDrawerNavigator = createDrawerNavigator();

export const DrawerNavigator = () => {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const user = useSelector((state) => state && state.auth && state.auth.user);
  const trips = useSelector(selectMytrips);
  const tripImage = trips && trips[0]?.ImageURL?.substr(8);
  const startDate = trips && new Date(trips[0]?.StartDate);
  const tripDate =
    startDate && `${startDate.getDate()}/${startDate.getMonth()}/${startDate.getYear()}`;
  const imageUrl = useSelector(selectUserProfileImage);
  const activeTintColor = Color.active;
  const inactiveTintColor = Color.primary;
  const labelStyle = { ...CommonProperties.fontFamily };
  const nextTrip = trips ? trips[0] : null;
  const isExpense = useSelector(isExpenseAllowed);
  const myTripsCount = useSelector(selectMytripsCount);
  const expenses = useSelector(selectExpenseList);
  const getNoOfExpenses = () => {
    if (isNullOrEmpty(expenses)) {
      return 0;
    }
    if (isNullOrEmpty(expenses)) {
      return 0;
    }
    return expenses?.length || 0;
  };
  if (AA_ENABLED) {
    return (
      <MainDrawerNavigator.Navigator
        drawerStyle={{
          backgroundColor: Color.aaColor,
        }}
        drawerContentOptions={{
          inactiveTintColor: Color.disabled,
          labelStyle: { ...CommonProperties.fontFamily },
        }}
        screenOptions={{
          drawerType: 'slide',
        }}
        drawerContent={(props) => (
          <View style={CommonStyles.flex1}>
            <DrawerContentScrollView {...props}>
              {user && (
                <>
                  <View style={styles.wrap}>
                    <Avatar source={imageUrl ? { uri: imageUrl } : null} />
                    <BaseText style={styles.textStyleAA}>
                      {user.FirstName} {user.LastName}
                    </BaseText>
                  </View>
                  {trips && (
                    <View style={[styles.wrap, { backgroundColor: Color.accent }]}>
                      <Avatar
                        source={
                          tripImage
                            ? {
                                uri: tripImage,
                              }
                            : null
                        }
                      />
                      <BaseText style={styles.textStyle}>
                        {trips[0]?.TripName} {'\n'}
                        {tripDate} {'\n'}
                        {'View next trip'}
                      </BaseText>
                    </View>
                  )}
                </>
              )}
              <CustomDrawerItemList {...props} user={user} />
              {user && (
                <Button
                  title={t('MainNavigator.Logout')}
                  onPress={() => {
                    dispatch(authActions.logout());
                  }}
                />
              )}
            </DrawerContentScrollView>
          </View>
        )}
      >
        {user ? (
          <MainDrawerNavigator.Screen
            name={Stacks.TabsStack}
            component={BottomTabs}
            options={{
              title: t('MainNavigator.SearchDrawerTitle'),
              drawerIcon: ({ color }) => <Icon size={24} name="search" color={color} />,
            }}
          />
        ) : (
          <MainDrawerNavigator.Screen
            name={Stacks.HomeStack}
            component={HomeNavigator}
            options={{
              title: t('MainNavigator.SearchDrawerTitle'),
              drawerIcon: ({ color }) => <Icon size={24} name="search" color={color} />,
            }}
          />
        )}
      </MainDrawerNavigator.Navigator>
    );
  }
  if (EVENTS_ENABLED) {
    return (
      <MainDrawerNavigator.Navigator
        screenOptions={{
          drawerType: 'slide',
        }}
        drawerContent={(props) => (
          <View style={CommonStyles.flex1}>
            <DrawerContentScrollView {...props}>
              {/* <View style={styles.wrap}>
                <Avatar source={imageUrl ? { uri: imageUrl } : null} />
                <BaseText style={styles.textStyle}>
                  {eventData !== undefined &&
                    eventData?.passengerList[0] != undefined &&
                    eventData?.passengerList[0].FirstName}{' '}
                  {eventData?.passengerList[0].LastName}
                </BaseText>
              </View> */}
              <CustomDrawerItemList
                activeTintColor={activeTintColor}
                inactiveTintColor={inactiveTintColor}
                labelStyle={labelStyle}
                {...props}
              />
            </DrawerContentScrollView>
            <View style={styles.versionContainer}>
              <BaseText>Version {__VERSION__}</BaseText>
            </View>
          </View>
        )}
      >
        <MainDrawerNavigator.Screen
          name={Stacks.HomeStack}
          component={HomeNavigator}
          options={{
            title: t('MainNavigator.SearchDrawerTitle'),
            drawerIcon: ({ color }) => <Icon size={24} name="search" color={color} />,
            headerShown: false,
          }}
        />

        {__DEV__ && (
          <MainDrawerNavigator.Screen
            name="IconSet"
            component={IconNavigator}
            options={{
              drawerIcon: ({ color }) => <Icon size={24} name="list" color={color} />,
            }}
          />
        )}
      </MainDrawerNavigator.Navigator>
    );
  }
  if (CREW_ENABLED) {
    return (
      <MainDrawerNavigator.Navigator
        screenOptions={{
          drawerType: 'slide',
        }}
        drawerContent={(props) => (
          <View style={CommonStyles.flex1}>
            <DrawerContentScrollView {...props}>
              <View style={styles.wrap}>
                <Avatar source={imageUrl ? { uri: imageUrl } : null} />
                <BaseText style={styles.textStyle}>
                  {user.FirstName} {user.LastName}
                </BaseText>
              </View>
              {trips && nextTrip && (
                <View style={styles.wrap}>
                  <Avatar
                    source={nextTrip.ImageURL ? { uri: changeCdnUrl(nextTrip.ImageURL) } : null}
                  />
                  <View style={styles.nextTripContainer}>
                    <BaseText>{nextTrip.Description}</BaseText>
                    <BaseText>{moment(nextTrip.StartDate).format('LL')}</BaseText>
                    <TouchableOpacity
                      onPress={() => {
                        dispatch(selectTrip(nextTrip));
                        props.navigation.navigate(Screens.TripHub, {
                          userType: userTypes.OWNER,
                        });
                      }}
                    >
                      <BaseText style={styles.nextTripButton}>
                        {t('MainNavigator.ViewNextTrip')}
                      </BaseText>
                    </TouchableOpacity>
                  </View>
                </View>
              )}
              <CustomDrawerItemList
                activeTintColor={activeTintColor}
                inactiveTintColor={inactiveTintColor}
                labelStyle={labelStyle}
                {...props}
                user={user}
              />
              <DrawerItem
                label={`${t('MainNavigator.Language')}: ${lngMap[i18n.language]}`}
                activeTintColor={activeTintColor}
                inactiveTintColor={inactiveTintColor}
                labelStyle={labelStyle}
                icon={({ color }) => <Icon name="swipe" color={color} size={24} />}
                onPress={() => props.navigation.navigate(Modals.LanguageModal)}
                {...props}
              />
              <Button
                title={t('MainNavigator.Logout')}
                onPress={() => {
                  dispatch(authActions.logout());
                }}
              />
            </DrawerContentScrollView>
            <View style={styles.versionContainer}>
              <BaseText>Version {__VERSION__}</BaseText>
            </View>
          </View>
        )}
      >
        <MainDrawerNavigator.Screen
          name={Stacks.TabsStack}
          component={BottomTabs}
          options={{
            title: t('MainNavigator.HomeDrawerTitle'),
            drawerIcon: ({ color }) => <Icon size={24} name="person" color={color} />,
            headerShown: false,
          }}
        />
        <MainDrawerNavigator.Screen
          name={Stacks.SettingsStack}
          component={SettingsNavigator}
          options={{
            title: t('MainNavigator.SettingsDrawerTitle'),
            drawerIcon: ({ color }) => {
              return <Icon size={24} name="settings" color={color} />;
            },
            headerShown: false,
          }}
        />
        {__DEV__ && (
          <MainDrawerNavigator.Screen
            name="IconSet"
            component={IconNavigator}
            options={{
              drawerIcon: ({ color }) => <Icon size={24} name="list" color={color} />,
              headerShown: false,
            }}
          />
        )}
      </MainDrawerNavigator.Navigator>
    );
  } else {
    return (
      <MainDrawerNavigator.Navigator
        screenOptions={{
          drawerType: 'slide',
        }}
        drawerContent={(props) => (
          <View style={CommonStyles.flex1}>
            <TouchableOpacity
              style={styles.icon}
              onPress={() => {
                navigation.dispatch(DrawerActions.toggleDrawer());
              }}
            >
              <Icon name="cancel" color={Color.primary} size={30} />
            </TouchableOpacity>
            <DrawerContentScrollView {...props}>
              <View style={styles.wrap}>
                <Avatar
                  style={styles.avatar}
                  isMainStackNavigator={true}
                  source={imageUrl ? { uri: imageUrl } : null}
                />
                <BaseText style={styles.textStyleName}>
                  {user.FirstName} {user.LastName}
                </BaseText>
              </View>
              <ProfileHeader
                trips={myTripsCount}
                reports={(isExpense && getNoOfExpenses()) || 0}
                enableExpense={isExpense}
                isMainStackNavigator={true}
              />
              {trips && nextTrip && (
                <View style={styles.wrap}>
                  <Avatar source={nextTrip.ImageURL ? { uri: nextTrip.ImageURL } : null} />
                  <View style={styles.nextTripContainer}>
                    <BaseText>{nextTrip.Description}</BaseText>
                    <BaseText>{moment(nextTrip.StartDate).format('LL')}</BaseText>
                    <TouchableOpacity
                      onPress={() => {
                        props.navigation.navigate(Screens.Receipt, {
                          tripKey: nextTrip.TripKey,
                        });
                      }}
                    >
                      <BaseText style={styles.nextTripButton}>
                        {t('MainNavigator.ViewNextTrip')}
                      </BaseText>
                    </TouchableOpacity>
                  </View>
                </View>
              )}

              <CustomDrawerItemList
                activeTintColor={activeTintColor}
                inactiveTintColor={inactiveTintColor}
                labelStyle={labelStyle}
                {...props}
                user={user}
              />
              <DrawerItem
                label={`${t('MainNavigator.Language')}: ${lngMap[i18n.language]}`}
                activeTintColor={activeTintColor}
                inactiveTintColor={inactiveTintColor}
                labelStyle={labelStyle}
                icon={({ color }) => <Icon name="swipe" color={color} size={24} />}
                onPress={() => props.navigation.navigate(Modals.LanguageModal)}
                {...props}
              />
              {isExpense && (
                <>
                  <BaseText style={styles.textStyle}>{t('Expense')}</BaseText>
                  <DrawerItem
                    label={`${t('MainNavigator.CreateExpense')}`}
                    activeTintColor={activeTintColor}
                    inactiveTintColor={inactiveTintColor}
                    labelStyle={labelStyle}
                    icon={({ color }) => <Icon name="clip" color={color} size={24} />}
                    onPress={() =>
                      props.navigation.navigate(Modals.TripExpenseAddModal, {
                        selectedType: MANUAL,
                      })
                    }
                    {...props}
                  />
                  <DrawerItem
                    label={`${t('MainNavigator.AddReceipt')}`}
                    activeTintColor={activeTintColor}
                    inactiveTintColor={inactiveTintColor}
                    labelStyle={labelStyle}
                    icon={({ color }) => <Icon name="camera" color={color} size={24} />}
                    onPress={() =>
                      props.navigation.navigate(Modals.TripExpenseAddModal, {
                        selectedType: RECEIPTS,
                      })
                    }
                    {...props}
                  />
                  <DrawerItem
                    label={`${t('MainNavigator.ViewCharges')}`}
                    activeTintColor={activeTintColor}
                    inactiveTintColor={inactiveTintColor}
                    labelStyle={labelStyle}
                    icon={({ color }) => <Icon name="payment" color={color} size={24} />}
                    onPress={() =>
                      props.navigation.navigate(Modals.TripExpenseAddModal, {
                        selectedType: CHARGES,
                      })
                    }
                    {...props}
                  />
                  <DrawerItem
                    label={`${t('MainNavigator.AddMileage')}`}
                    activeTintColor={activeTintColor}
                    inactiveTintColor={inactiveTintColor}
                    labelStyle={labelStyle}
                    icon={({ color }) => <Icon name="car" color={color} size={24} />}
                    onPress={() =>
                      props.navigation.navigate(Modals.TripExpenseAddModal, {
                        selectedType: MILEAGE,
                      })
                    }
                    {...props}
                  />
                </>
              )}
              <Button
                title={t('MainNavigator.Logout')}
                onPress={() => {
                  dispatch(authActions.logout());
                }}
              />
            </DrawerContentScrollView>
            <View style={styles.versionContainer}>
              <BaseText>Version {__VERSION__}</BaseText>
            </View>
          </View>
        )}
      >
        <MainDrawerNavigator.Screen
          name={Stacks.TabsStack}
          component={BottomTabs}
          options={{
            title: t('MainNavigator.SearchDrawerTitle'),
            drawerIcon: ({ color }) => <Icon size={24} name="search" color={color} />,
            headerShown: false,
          }}
        />
        <MainDrawerNavigator.Screen
          name={Stacks.SettingsStack}
          component={SettingsNavigator}
          options={{
            title: t('MainNavigator.SettingsDrawerTitle'),
            drawerIcon: ({ color }) => {
              return <Icon size={24} name="settings" color={color} />;
            },
            headerShown: false,
          }}
        />
        {__DEV__ && (
          <MainDrawerNavigator.Screen
            name="IconSet"
            component={IconNavigator}
            options={{
              drawerIcon: ({ color }) => <Icon size={24} name="list" color={color} />,
              headerShown: false,
            }}
          />
        )}
      </MainDrawerNavigator.Navigator>
    );
  }
};

const styles = StyleSheet.create({
  wrap: {
    flex: 1,
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'row',
    ...CommonProperties.p3,
  },
  nextTripContainer: {
    flexDirection: 'column',
  },
  textStyle: {
    ...CommonProperties.h3,
    ...CommonProperties.p3,
  },
  textStyleName: {
    ...CommonProperties.h2,
    ...CommonProperties.p3,
  },
  textStyleAA: {
    ...CommonProperties.p3,
    color: Color.accent,
    ...CommonProperties.h3,
  },
  nextTripButton: {
    color: Color.primary,
  },
  versionContainer: {
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  avatar: {
    borderWidth: 0.3,
    borderColor: '#fff',
    shadowColor: '#000',
    shadowOffset: { width: -1, height: 1 },
    shadowOpacity: 0.3,
    shadowRadius: 5,
  },
  icon: {
    top: 5,
    position: 'absolute',
    right: 5,
    zIndex: 999,
  },
});
